module.exports = __webpack_public_path__ + "img/Metastasis-BLCA_GSE171351.9b8cd11e.png";